
export const loginStyles = theme => ({

    loginContainer: {
        overflow: 'hidden',
        height: '100%',
        width: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        padding: '10% 0',
        backgroundColor: theme.palette.darkBlue
    },
    bgImageContainer:{
        position: 'relative'
    },
    mainHeading:{
        fontSize: '34px',
        color: 'white',
        fontWeight: 'bold'
    },
    subHeading:{
        fontSize: '15px',
        color: 'white',
        width: '309px'
    },
    wave:{
        left: '88%',
        top: '73%',
        position: 'absolute',

    },
    headingIcon:{
        width: '11px',
        height: '83px',
        borderRadius: '5.5px',
        position: 'absolute',
        top: '32%',
        left: '26%',
        backgroundColor: '#97d416'
    },
    headingContainer:{
        width: '385px',
        position: 'absolute',
        top: '31%',
        left: '30%'
    },
    bgImage:{
        maxWidth: '100%',
        maxHeight: '100%',
        display: 'block'
    },
    registerContainer: {
        overflow: 'scroll',
        height: 'auto',
        width: '60%',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        padding: '2% 0',
        backgroundColor: theme.palette.darkBlue
    }, 
    verifyContainer:{

    },
    button: {
        backgroundColor: theme.palette.blue,
        color: theme.palette.white,
        textTransform: 'unset',
        height: '48px',
        borderRadius: '6px',
        marginTop: '20px',

    },
    formStyle: {
        width: '380px',
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        },
    },
    textFieldInput: {
        padding: '14px 20px',
        fontSize: '15px',
        height: '50px',
        boxSizing: 'border-box'
    },
    formControl: {
        width: '100%'
    },
    errorStyle: {
        color: theme.palette.red,
        fontSize: '12px',
        marginBottom: '5px'
    },
    signup: {
        color: theme.palette.lightBlueGray,
        textTransform: 'unset',
    },
    tokenError: {
        color: theme.palette.errorRed,
        marginBottom: '5px'
    },
    bottomAction: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '380px',
        marginTop: '10px',
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        },
    },
    action: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '500px'
    },
    buttonFlex: {
        display: 'flex',
        justifyContent: 'space-around'
    },
    outerLoader: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '400px'
    },
    progress: {
        color: theme.palette.red,
    },
    rowFlex:{
        display: 'flex',
        flexDirection: 'row',
        height: '100%'
    },
    svg:{
        marginRight: '0.5vw'
    },
    loaderDiv: {
        backgroundColor: theme.palette.dark,
        height: '100%'
      },
      loading: {
        top: '40%',
        right: '45%',
        position: 'fixed',
        color: theme.palette.blue,
      },
      pageHeading:{
          fontSize: '22px',
          fontWeight: '500',
          color: theme.palette.lightBlueGray
      },
      descText:{
        fontSize: '13px',
        color: theme.palette.lightBlueGray,
        width: '380px',
        height:'40px'
    },
    formField: {
        padding: '14px 20px',
        fontSize: '15px',
        height: '50px',
        boxSizing: 'border-box',
        width: '380px'
    },
    formContainer:{
        width: '380px',
        marginTop: '-10px !important'
    },
    backHomeText:{
        fontSize: '13px',
        color: theme.palette.lightBlueGray,
        width: '380px',
        height:'40px',
        textAlign: 'center',
        margin: '10vh 0vw',
        cursor: 'pointer'
    },
    resetContainer:{
        
    },
    showPassword:{
        cursor: 'pointer',
        color: theme.palette.cloudyBlue
    }

})
